/* eslint-disable */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CURATION_REQUEST } from 'estimate_list/reducers/initial'
import { scrollTo } from 'estimate_list/libs/util'
import Curations from './curations'
import { useLocation } from "react-router";
import SEO from "../../libs/seo";

const Curation = (props) => {
    const { lists, minishopInfo, domain, loading } = useSelector(state => state.initial)
    let cate = '1010100000'

    const firstPathName = window.location.pathname.split('/')[1]
    if (firstPathName === 'list') {
        cate = window.location.pathname.split('/')[2]
    }

    const idx_b_manager = minishopInfo?.idx_b_manager || 1

    const dispatch = useDispatch()
    const route = useRouteMatch()
    const {search} = useLocation()
    const [curationName, setCurationName] = useState(null)

    useEffect(() => {
        if (idx_b_manager) {
            fetchCuration(cate, idx_b_manager, domain)
        }
    }, [idx_b_manager])

    useEffect(() => {
        if(!route.params.idx_curation) {
            autoScroll()
            return
        }

        if(lists.curation?.curation?.length > 0) {
            const idx_curation = parseInt(route.params.idx_curation)

            let curationName = ''
            for (const item of lists.curation.curation) {
                if (item.pr_idx === idx_curation) {
                    curationName = item.nm_curation
                    break
                }
            }

            setCurationName(curationName)
        }
    }, [lists])

    useEffect(() => {
        if (lists.curation?.curation?.length > 0 && route.params.idx_curation && !loading.setSearchDataOption) {
            setTimeout(() => {
                scrollTo('#curation_' + route.params.idx_curation, -71)
            }, 500)
        }
    }, [lists.curation?.curation, route.params.idx_curation, loading.setSearchDataOption])

    const fetchCuration = (cate, idx_b_manager, domain) => {
        dispatch({
            type: CURATION_REQUEST,
            data: { cate, idx_b_manager, domain, search}
        })
    }

    const goCuration = (index, curationName) => () => {
        window.history.pushState('', null, `/list/${cate}/curation/${index}`);
        if(!document.getElementById('curation_'+index)){
            autoScroll()
        }else{
            scrollTo('#curation_' + index, -71)
        }
        setCurationName(curationName)
    }

    const autoScroll = () => {
        scrollTo('#nav_spy', -71)
    }

    return (
        <>
            {props.cateName != null && (
                <>
                    {domain === 'shopping' && (
                        <>
                            {route.path === '/list/:categoryID/curation' && (
                                <SEO
                                    title={`${props.cateName} 큐레이션 : 행복쇼핑 가격비교`}
                                    description={`${props.cateName} 큐레이션 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                    ogTitle={`${props.cateName} 큐레이션 : 행복쇼핑 가격비교`}
                                    ogSiteName={`${props.cateName} 큐레이션 : 행복쇼핑 가격비교`}
                                />
                            )}
                        </>
                    )}
                    {domain === 'pc' && (
                        <>
                            {route.path === '/list/:categoryID/curation' && (
                                <SEO
                                    title={`${props.cateName} 큐레이션 PC견적 : 행복쇼핑`}
                                    description={`${props.cateName} 큐레이션 PC견적 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                    ogTitle={`${props.cateName} 큐레이션 PC견적 : 행복쇼핑`}
                                    ogSiteName={`${props.cateName} 큐레이션 PC견적 : 행복쇼핑`}
                                />
                            )}
                        </>
                    )}
                </>
            )}
            {curationName != null && (
                <>
                    {domain === 'shopping' && (
                        <>
                            {(route.path === '/list/:categoryID/curation/:idx_curation' || route.path === '/list/:categoryID/curation') && (
                                <SEO
                                    title={`${curationName} : 행복쇼핑 가격비교`}
                                    description={`${curationName} : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                    ogTitle={`${curationName} : 행복쇼핑 가격비교`}
                                    ogSiteName={`${curationName} : 행복쇼핑 가격비교`}
                                />
                            )}
                        </>
                    )}
                    {domain === 'pc' && (
                        <>
                            {(route.path === '/list/:categoryID/curation/:idx_curation' || route.path === '/list/:categoryID/curation') && (
                                <SEO
                                    title={`${curationName} PC견적 : 행복쇼핑`}
                                    description={`${curationName} PC견적 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                    ogTitle={`${curationName} PC견적 : 행복쇼핑`}
                                    ogSiteName={`${curationName} PC견적 : 행복쇼핑`}
                                />
                            )}
                        </>
                    )}
                </>
            )}
            <Style cdnimg={process.env.REACT_APP_CDN_IMG}>
                <div className="mediumguide_head">
                    <h2 className="tit-h2">
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/tit_estimate_curation.png`}
                            alt="최고의 전문가가 소비자의 마음으로 선택한 행쇼 큐레이션"
                        />
                    </h2>
                </div>
                {loading.setCuration ? (
                    <Loading>
                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/happy_loading_5.gif`} alt="" width="60" height="69"/>
                    </Loading>
                ) : lists.curation?.curation?.length > 0 ? (
                    <>
                        <div className="curation_tab">
                            <div className="in">
                                {lists.curation.curation.map((v, i) => (
                                    <button key={i} type="button" className={`btn ${/*active*/i}`} onClick={goCuration(v.pr_idx, v.nm_curation)}>
                                        {v.nm_curation}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="mediumguide_contents">
                            {lists.curation.curation.map((v, i) => (
                                <Curations key={i} curation={v} id={`curation_${v.pr_idx}`} index={i} />
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="no_content">
                        <div><img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/img_happyshopping_ci_simbol.png`} alt="" /></div>
                        <p><b>큐레이션</b> 준비중 입니다.</p>
                    </div>
                )}
            </Style>
        </>
    )
}

const Style = styled.div`
    min-height: 600px;

    .mediumguide_head {
        height: 156px;
        padding: 38px 0 0 23px;
        background: ${(props) => `url("${props.cdnimg}/img_static/img_pres/_v3/bg_estimate_curation_head.png") no-repeat 95% 10px`};
    }
    .curation_tab {
        margin: 0 0 20px;
        padding-left: 1px;

        .in {
            display: flex;
            flex-wrap: wrap;

            button {
                width: calc(33.333% + 1px);
                display: inline-block;
                margin: 0 0 -1px -1px;
                font-size: 16px;
                height: 50px;
                line-height: 48px;
                border: 1px solid #0f4f9f;
                color: #333;
                text-align: center;
                padding: 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                    background: #f8f8f8
                }
                &.active {
                    position: relative;
                    color: #fff;
                    font-weight: bold;
                    background: #0f4f9f;
                }
            }
        }
    }
    .no_content {
        text-align: center;
        padding: 140px 0 0;

        div {
            margin: 0 0 5px;
        }
        p {
            font-size: 16px;
        }
    }
`
const Loading = styled.div`
    display: flex;
    width: 100%;
    height: 300px;
    align-items: center;
    justify-content: center;
`

export default Curation



// WEBPACK FOOTER //
// ./src/estimate_list/components/curation/index.js